import Parse from "parse";

class UserService {
  private static _instance: UserService;

  public static get instance(): UserService {
    if (!UserService._instance) {
      UserService._instance = new UserService();
    }
    return UserService._instance;
  }

  public async getInitialState() {}

  getUserWallets = async (email: string) => {
    try {
      const result = await Parse.Cloud.run("getUserWallets", { email });
      return result.wallets;
    } catch (error) {
      console.error("Error getting user wallets:", error);
      throw error;
    }
  };

  fetchAndStoreSecondaryWallet = async (email: string) => {
    try {
      const result = await Parse.Cloud.run("fetchAndStoreSecondaryWallet", { email });
      return result;
    } catch (error) {
      console.error("Error fetching secondary wallet:", error);
      throw error;
    }
  };

  getIdentityByEmail = async (email: string) => {
    try {
      const response = await Parse.Cloud.run("getIdentityAddressByEmail", { email });
      return response || null;
    } catch (error: any) {
      console.error(`Failed to get identity by email: ${error.message}`);
      return null;
    }
  };

  saveUserWallet = async (email: string, walletData: any) => {
    try {
      const result = await Parse.Cloud.run("saveUserWallet", {
        email,
        ...walletData,
      });
      return result;
    } catch (error) {
      console.error("Error saving wallet:", error);
      throw error;
    }
  };

  // Deletes a UserWallets row directly. Only valid for wallets that were
  // never linked on-chain
  deleteUserWallet = async (id: string) => {
    try {
      const result = await Parse.Cloud.run("deleteUserWallet", { id });
      return result;
    } catch (error) {
      console.error("Error deleting wallet:", error);
      throw error;
    }
  };

  // Sends the "Identity Approved" email.
  sendApprovalEmail = async (email: string) => {
    try {
      const result = await Parse.Cloud.run("sendApprovalEmail", { email });
      return result;
    } catch (error) {
      console.error("Error sending approval email:", error);
      throw error;
    }
  };

  // Returns the audit history of status changes (Denied / Under Review /
  // Tester) for a single user, newest first. Pass userId or walletAddress.
  getUserStatusHistory = async (params: { userId?: string; walletAddress?: string; status?: string; page?: number; limit?: number }) => {
    try {
      const result = await Parse.Cloud.run("getUserStatusHistory", params);
      return result; // { data, pagination }
    } catch (error) {
      console.error("Error getting user status history:", error);
      throw error;
    }
  };

  // Returns the Persona-reset audit history for a single user, newest first.
  // Pass userId or walletAddress.
  getPersonaResetHistory = async (params: { userId?: string; walletAddress?: string; page?: number; limit?: number }) => {
    try {
      const result = await Parse.Cloud.run("getPersonaResetHistory", params);
      return result; // { data, pagination }
    } catch (error) {
      console.error("Error getting persona reset history:", error);
      throw error;
    }
  };
}

export default UserService.instance;
